import React from "react";
import { Zap, CalendarClock, Car } from "lucide-react";

const TILES = [
  { key: "instant", label: "Maintenant", Icon: Zap, tone: "bg-primary text-primary-foreground", iconTone: "text-primary" },
  { key: "scheduled", label: "Programmer", Icon: CalendarClock, tone: "bg-accent text-accent-foreground", iconTone: "text-accent-foreground" },
  { key: "published", label: "Trajets publiés", Icon: Car, tone: "bg-white text-foreground", iconTone: "text-primary" },
];

// 3 tuiles carrées en ligne sur l'accueil passager (proposition B).
export default function ClientHomeChoices({ onPick }) {
  return (
    <div className="mt-4 grid grid-cols-3 gap-2.5" data-testid="client-home-choices">
      {TILES.map(({ key, label, Icon, tone, iconTone }, i) => (
        <button
          key={key}
          type="button"
          onClick={() => onPick(key)}
          data-testid={`client-choice-${key}`}
          className={`street-press flex aspect-square flex-col items-start justify-between rounded-3xl p-3 text-left street-border street-shadow animate-fade-up ${tone}`}
          style={{ animationDelay: `${i * 70}ms`, animationFillMode: "both" }}
        >
          <span className="grid h-10 w-10 place-items-center rounded-2xl bg-white street-border-thin rotate-[-4deg]">
            <Icon className={`h-5 w-5 ${iconTone}`} strokeWidth={2.75} />
          </span>
          <span className="font-[Outfit] text-[14px] font-black leading-tight">{label}</span>
        </button>
      ))}
    </div>
  );
}
